import React, { useState, useEffect } from "react";
import { Button, Modal, Table, Row } from "react-bootstrap";
import _ from "lodash";
import ApiTransaction from "../../../../../core/api/api.transaction";
import SplitNumber from "../../../_Components/SplitNumber";
import SwalMessage from "../../../_Components/SwalMessage";
import CloseIcon from "@mui/icons-material/CloseRounded";

function ModalHistoryTransaction({ show, data }) {
  const [sum, setSum] = useState(0);
  const [transactionList, setTransactionList] = useState([]);
  const headerItems = [
    {
      name: "",
      className1: "bg-light-primary",
      className2: "text-center text-muted",
    },
    {
      name: "شماره",
      className1: "bg-light-primary",
      className2: "text-center text-muted",
    },
    {
      name: "تاریخ",
      className1: "bg-light-primary",
      className2: "text-center text-muted",
    },
    {
      name: "نوع",
      className1: "bg-light-primary",
      className2: "text-center text-muted",
    },
    {
      name: "حساب مبدا",
      className1: "bg-light-primary",
      className2: "text-center text-muted",
    },
    {
      name: "حساب مقصد",
      className1: "bg-light-primary",
      className2: "text-center text-muted",
    },
    {
      name: "مبلغ",
      className1: "bg-light-primary",
      className2: "text-center text-muted",
    },
  ];
  const handleClose = () => {
    data.callBack(false);
  };
  useEffect(() => {
    (async () => {
      const response = await ApiTransaction.getTransactionByBasketId(data.basketId);
      if (response.succeeded) {
        setTransactionList(response.data);
        // حاصل جمع ایتم ها
        let sum =
          response.data.filter((id) => id.type === 1 || id.type === 4).reduce((a, v) => (a = a + v.price), 0) -
          response.data.filter((id) => id.type === 2 || id.type === 3).reduce((a, v) => (a = a + v.price), 0);
        setSum(sum);
      } else {
        SwalMessage({
          title: response.message ? response.message : "اشکال در دریافت اطلاعات",
          iSsuccess: response.succeeded,
        });
      }
    })();
    return () => { };
  }, []);
  return (
    <>
      <Modal size="xl" onHide={handleClose} show={show}>
        <Modal.Header closeButton>
          <Modal.Title>تاریخچه تراکنش ها </Modal.Title>
          {/* <Button variant="none" onClick={handleClose}>
                        <i className="fas fa-long-arrow-alt-left text-dark"></i>
                    </Button> */}
        </Modal.Header>
        <Modal.Body>
          <Table striped hover responsive="md" bordered={false} borderless={false}>
            <thead>
              <tr className="text-center ">
                {headerItems.map((header, index) => {
                  return (
                    <th key={index} className={header.className1}>
                      <small className={header.className2}>{header.name}</small>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {transactionList.map((item, index) => (
                <tr key={index} className="text-center">
                  <td>
                    <small>{index + 1}</small>
                  </td>
                  <td>
                    <small>{item.id}</small>
                  </td>
                  <td>
                    <small>{item.completionDate + " " + item.completionTime}</small>
                  </td>
                  <td>
                    <small>{item.typeS}</small>{" "}
                  </td>
                  <td>
                    <small>
                      {(!_.isEmpty(item.sourceAccountAccountNumber) ? item.sourceAccountAccountNumber : "") +
                        " - " +
                        (!_.isEmpty(item.sourceAgencyName) ? item.sourceAgencyName : "")}
                    </small>
                  </td>
                  <td>
                    <small>
                      {(!_.isEmpty(item.destinationAccountAccountNumber) ? item.destinationAccountAccountNumber : "") +
                        " - " +
                        (!_.isEmpty(item.destinationAgencyName) ? item.destinationAgencyName : "")}
                    </small>
                  </td>
                  <td className={item.type === 1 || item.type === 4 ? "text-success" : "text-danger"}>
                    <SplitNumber number={item.price} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {/* نتیجه */}
          <Row
            className="w-100 text-left mx-0 p-4 bg-light-primary "
            style={{ borderBottomRightRadius: "15px", borderBottomLeftRadius: "15px" }}
          >
            <span className="w-100 px-5" style={{ textAlign: "left" }}>
              {" "}
              جمع کل : <SplitNumber number={sum} />
            </span>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon className="mr-1" />
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalHistoryTransaction;
